import { useMutation } from '@tanstack/react-query';

import { Slide } from '../components/SlideComponents/slide.types';
import BackendService from '../services/backendService';
import { LessonAttachment } from '../services/backendService/backendService';
import useRouterMatch from './useRouterMatch';

const useCreateLessonFromSampleEdit = (tenantId: string) => {
  const { router } = useRouterMatch();

  const { mutate: createLessonAndEdit, isLoading: isCreatingLessonAndEdit } = useMutation(
    ({
      presentationId,
      slides,
      tenantId,
      lessonAttachments,
      onSuccess,
    }: {
      presentationId: string;
      slides: Slide[];
      tenantId: string;
      onSuccess?: () => void;
      lessonAttachments?: LessonAttachment[];
    }) => {
      return BackendService.instance.presentations.createLessonFromSample({
        presentationId,
        slides,
        tenantId,
        lessonAttachments,
      });
    },
    {
      onSuccess: (response, { onSuccess }) => {
        if (onSuccess) {
          onSuccess();
        }
        router.push(`/${tenantId}/lessons/${response.presentation.id}/edit`);
      },
    },
  );

  return {
    createLessonAndEdit,
    isCreatingLessonAndEdit,
  };
};

export default useCreateLessonFromSampleEdit;
